import { defineComponent as _defineComponent } from 'vue';
import { usePage } from '@inertiajs/inertia-vue3';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import DataTable from '@/Components/DataTable.vue';
import Column from 'primevue/column';
import { FilterMatchMode, FilterOperator } from 'primevue/api';
import Calendar from 'primevue/calendar';
import { onMounted, ref } from 'vue';
import { computed } from '@vue/reactivity';
import { Inertia } from '@inertiajs/inertia';
import RecordsTableHeader from '../../../Components/RecordsTableHeader.vue';
import { concatPlotsCodes, formatISODate } from '../../../Services/Utils';
import { trans, transChoice } from 'laravel-vue-i18n';
import { useMitt } from '../../../Plugins/mitt';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Table',
    setup(__props, { expose }) {
        expose();
        const emitter = useMitt();
        const selectedRecords = ref([]);
        const filters = ref({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            code: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
            },
            plot_codes: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
            },
            date: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
            },
        });
        const globalFilterFields = ['code', 'plot_codes', 'description'];
        const page = usePage();
        const records = computed(() => {
            const records = page.props.value.symptomRecords || [];
            records.map((record) => {
                record.plot_codes = concatPlotsCodes(record.plots);
                return record;
            });
            return records;
        });
        const reloadRecords = () => {
            Inertia.reload({
                only: ['symptomRecords'],
            });
        };
        onMounted(() => reloadRecords());
        const openDetails = async (data) => emitter.emit('open-symptom-record-details', data);
        const edit = async (data) => emitter.emit('open-symptom-record-form', data);
        emitter.on('symptom-record-saved', () => reloadRecords());
        const __returned__ = { emitter, selectedRecords, filters, globalFilterFields, page, records, reloadRecords, openDetails, edit, get InputText() { return InputText; }, get Button() { return Button; }, DataTable, get Column() { return Column; }, get Calendar() { return Calendar; }, RecordsTableHeader, get formatISODate() { return formatISODate; }, get trans() { return trans; }, get transChoice() { return transChoice; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
